import React from "react";
import { DownwardArrow } from "./DownArrow.styles";

const DownArrow = () => {
    return (
        <DownwardArrow />
    )
}

export default DownArrow;